import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 4"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <rect id="Minimize" width="20" height="4" rx="1.5" ry="1.5" />{" "}
  </svg>
))
